import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {IntegracaoOpendeliveryService} from '../../services/integracaoopendelivery.service';

@Component({
  selector: 'app-tela-integracao-opendelivery-ss',
  templateUrl: './tela-integracao-opendelivery-ss.component.html',
  styleUrls: ['./tela-integracao-opendelivery-ss.component.scss']
})
export class TelaIntegracaoOpendeliverySsComponent implements OnInit {
  @Input() empresa: any = {};
  @ViewChild('frm', {}) frm: any;
  integracao: any = {modoConfiguracao: 'manual', usarTokenFixo: false, usarAuthorizationCode: false, pollingAtivo: false, sempreConfirmarPedidos: false};
  softwareService: any = {merchantId: '', integracoes: []};
  integracoes: any[] = [];
  modoTela: 'listagem' | 'escolha' | 'formulario' = 'listagem';
  processandoIntegracaoId: number = null;
  mensagemLista = '';
  erroLista = '';
  apiKeyGerada = '';
  textoCopiado = '';
  processando = false;
  autenticacaoValidada = false;
  mensagemTesteAutenticacao = '';
  erroTesteAutenticacao = '';
  mensagemOperacao = '';
  erroOperacao = '';
  operacaoEmExecucao = '';
  ultimaOperacao = '';
  mensagemSalvar = '';
  erroSalvar = '';
  erroAtivacao = '';
  confirmandoTrocaParaPolling = false;
  mensagemTrocaRecebimento = '';
  erroTrocaRecebimento = '';
  urlWebhookEdicao = '';
  mensagemWebhook = '';
  erroWebhook = '';
  mensagem = '';
  erro = '';

  constructor(private service: IntegracaoOpendeliveryService) {}

  ngOnInit() {
    this.carregue();
  }

  get urlMerchant() {
    return this.integracao.urlMerchant || '';
  }

  get urlWebhookOnboarding() {
    return this.integracao.urlWebhookOnboarding || '';
  }

  get conexaoAiqfomePendente(): boolean {
    return this.integracao.modoConfiguracao === 'aiqfome' &&
      this.integracao.oauthAutorizado && !this.integracao.onboardingConcluido;
  }

  get modoAutenticacao(): string {
    if(this.integracao.usarTokenFixo) return 'token-fixo';
    if(this.integracao.usarAuthorizationCode) return 'autorizacao-lojista';
    return 'credenciais-manuais';
  }

  get nomeModoAutenticacao(): string {
    if(this.modoAutenticacao === 'token-fixo') return 'Token fixo';
    if(this.modoAutenticacao === 'autorizacao-lojista') return 'Autorização do lojista';
    return 'Credenciais manuais';
  }

  get quantidadeAtivas(): number {
    return this.integracoes.filter((item: any) => item.ativa).length;
  }

  get quantidadeWebhook(): number {
    return this.integracoes.filter((item: any) => item.ativa && !!item.urlWebhookOnboarding).length;
  }

  get quantidadePolling(): number {
    return this.integracoes.filter((item: any) => item.ativa && item.pollingAtivo).length;
  }

  carregue() {
    this.execute(() => this.service.obtenhaSoftwareService(), (dados: any) => {
      this.softwareService = dados || {merchantId: '', integracoes: []};
      this.integracoes = this.softwareService.integracoes || [];
      const idUrl = Number(new URLSearchParams(window.location.search).get('integracao')) || null;
      const selecionada = this.integracoes.find((item: any) => Number(item.id) === idUrl);
      if(selecionada) this.selecioneIntegracao(selecionada);
      else if(this.integracoes.length) this.exibaListagem();
      else this.novaIntegracao();
    }, false);
  }

  novaIntegracao() {
    this.modoTela = 'escolha';
    this.mensagemLista = '';
    this.erroLista = '';
    this.integracao = {modoConfiguracao: 'manual', usarTokenFixo: false, usarAuthorizationCode: false,
      pollingAtivo: false, sempreConfirmarPedidos: false};
    this.apiKeyGerada = '';
    this.urlWebhookEdicao = '';
    this.autenticacaoValidada = false;
    this.limpeMensagens();
    if(this.frm) this.frm.form.markAsPristine();
  }

  selecioneModoNovaIntegracao(modo: 'manual' | 'aiqfome') {
    this.integracao = {modoConfiguracao: modo, usarTokenFixo: false, usarAuthorizationCode: false,
      pollingAtivo: false, sempreConfirmarPedidos: false};
    this.apiKeyGerada = '';
    this.urlWebhookEdicao = '';
    this.autenticacaoValidada = false;
    this.limpeMensagens();
    this.modoTela = 'formulario';
    if(this.frm) this.frm.form.markAsPristine();
  }

  exibaListagem() {
    this.modoTela = 'listagem';
    this.mensagemLista = '';
    this.erroLista = '';
    this.limpeMensagens();
  }

  selecioneIntegracao(item: any) {
    this.mensagemLista = '';
    this.erroLista = '';
    const integracao = Object.assign({}, item || {});
    this.apiKeyGerada = integracao.apiKey || '';
    delete integracao.apiKey;
    this.integracao = Object.assign({modoConfiguracao: 'manual', usarTokenFixo: false,
      usarAuthorizationCode: false, pollingAtivo: false, sempreConfirmarPedidos: false}, integracao);
    const urlRegistrada = String(this.integracao.urlWebhookOnboarding || '');
    const usaRotaAntiga = /\/opendelivery\/ss\/v1\/integracoes\/[^/]+\/newEvent\/?$/i.test(urlRegistrada);
    this.urlWebhookEdicao = usaRotaAntiga ?
      urlRegistrada.replace(/\/integracoes\/[^/]+\/newEvent\/?$/i, '/newEvent') : urlRegistrada;
    this.autenticacaoValidada = false;
    this.limpeMensagens();
    this.modoTela = 'formulario';
    if(this.frm) this.frm.form.markAsPristine();
  }

  nomeParceiro(item: any): string {
    return item && item.modoConfiguracao === 'aiqfome' ? 'aiqfome' : (item && item.nomeAplicacao || 'OpenDelivery');
  }

  formaRecebimento(item: any): string {
    if(item && item.urlWebhookOnboarding) return 'Webhook';
    if(item && item.pollingAtivo) return 'Polling automático';
    return 'Não configurado';
  }

  nomeAutenticacao(item: any): string {
    if(item && item.usarTokenFixo) return 'Token fixo';
    if(item && item.usarAuthorizationCode) return 'Autorização do lojista';
    return 'Credenciais manuais';
  }

  async alterarAtivacaoDaLista(item: any, ativar: boolean): Promise<void> {
    if(!item || this.processandoIntegracaoId != null) return;
    this.processandoIntegracaoId = item.id;
    this.mensagemLista = '';
    this.erroLista = '';
    try {
      const dados: any = ativar ? await this.service.ativeSoftwareService(item.id) :
        await this.service.desativeSoftwareService(item.id);
      this.atualizeIntegracaoNaLista(dados);
      this.mensagemLista = `Integração ${ativar ? 'ativada' : 'desativada'}.`;
    } catch(erro) {
      this.erroLista = String(erro && (erro.message || erro) || 'Não foi possível alterar a integração.');
    } finally {
      this.processandoIntegracaoId = null;
    }
  }

  private atualizeIntegracaoNaLista(dados: any) {
    const indice = this.integracoes.findIndex((atual: any) => Number(atual.id) === Number(dados && dados.id));
    const item = Object.assign({}, indice >= 0 ? this.integracoes[indice] : {}, dados || {});
    if(this.apiKeyGerada && Number(item.id) === Number(this.integracao.id || item.id))
      item.apiKey = this.apiKeyGerada;
    if(indice >= 0) this.integracoes.splice(indice, 1, item);
    else this.integracoes.push(item);
  }

  private limpeMensagens() {
    this.mensagem = '';
    this.erro = '';
    this.mensagemSalvar = '';
    this.erroSalvar = '';
    this.erroAtivacao = '';
  }

  salvar() {
    this.mensagemSalvar = '';
    this.erroSalvar = '';
    this.erroAtivacao = '';
    this.mensagem = '';
    this.erro = '';
    if(this.integracao.modoConfiguracao !== 'aiqfome' && !this.integracao.usarTokenFixo && !this.integracao.usarAuthorizationCode && !this.autenticacaoValidada) {
      this.erroSalvar = 'Teste as credenciais OAuth antes de salvar.';
      return;
    }
    if(this.frm && !this.frm.valid) {
      this.erroSalvar = 'Verifique os campos obrigatórios.';
      return;
    }
    this.processando = true;
    this.service.salveSoftwareService(this.integracao).then((dados: any) => {
      if(dados && dados.apiKey) {
        this.apiKeyGerada = dados.apiKey;
        delete dados.apiKey;
      }
      this.integracao = Object.assign({modoConfiguracao: 'manual', usarTokenFixo: false, usarAuthorizationCode: false, pollingAtivo: false, sempreConfirmarPedidos: false}, dados || {});
      this.atualizeIntegracaoNaLista(dados);
      if(!this.softwareService.merchantId)
        this.service.obtenhaSoftwareService().then((config: any) => this.softwareService.merchantId = config.merchantId);
      this.autenticacaoValidada = !this.integracao.usarTokenFixo;
      this.mensagemSalvar = 'Configuração salva.';
      if(this.frm) this.frm.form.markAsPristine();
    }).catch((erro: any) => {
      this.erroSalvar = erro && (erro.message || erro);
    }).then(() => this.processando = false);
  }

  normalizarNomeAplicacao(valor: string) {
    this.integracao.nomeAplicacao = String(valor || '').replace(/\s+/g, '').toLowerCase();
  }

  autenticacaoAlterada() {
    this.autenticacaoValidada = false;
    this.mensagemTesteAutenticacao = '';
    this.erroTesteAutenticacao = '';
    this.mensagemSalvar = '';
    this.erroSalvar = '';
    this.erroAtivacao = '';
  }

  conectarAiqfome() {
    this.execute(async () => {
      this.integracao = await this.service.salveSoftwareService(this.integracao);
      this.atualizeIntegracaoNaLista(this.integracao);
      return this.service.inicieAutorizacaoSoftwareService(this.integracao.id);
    }, (dados: any) => window.location.assign(dados.url));
  }

  concluirAiqfome() {
    this.execute(() => this.service.executeOnboardingSoftwareService(this.integracao.id), (dados: any) => {
      this.integracao = dados;
      this.atualizeIntegracaoNaLista(dados);
      this.mensagem = 'Loja conectada ao aiqfome e integração ativada.';
    });
  }

  autorizarParceiro() {
    this.execute(() => this.service.inicieAutorizacaoSoftwareService(this.integracao.id), (dados: any) => {
      window.location.assign(dados.url);
    });
  }

  alterarModoAutenticacao(modo: string) {
    this.integracao.usarTokenFixo = modo === 'token-fixo';
    this.integracao.usarAuthorizationCode = modo === 'autorizacao-lojista';
    if(this.frm) this.frm.form.markAsDirty();
    this.autenticacaoAlterada();
    if(this.integracao.usarAuthorizationCode &&
      ['aiqfome', 'aiquefome'].indexOf(this.integracao.nomeAplicacao) >= 0) {
      this.integracao.authUrl = 'https://id.magalu.com/oauth/token';
      this.integracao.authorizationUrl = 'https://id.magalu.com/login';
      this.integracao.oauthScope = 'aqf:store:create aqf:order:read aqf:order:create';
    }
  }

  testarAutenticacao() {
    this.autenticacaoValidada = false;
    this.mensagemTesteAutenticacao = '';
    this.erroTesteAutenticacao = '';
    this.mensagemSalvar = '';
    this.erroSalvar = '';
    this.mensagem = '';
    this.erro = '';
    this.processando = true;
    this.service.testeAutenticacaoSoftwareService(this.integracao).then((dados: any) => {
      this.autenticacaoValidada = true;
      this.mensagemTesteAutenticacao = dados.mensagem;
    }).catch((erro: any) => {
      this.erroTesteAutenticacao = erro && (erro.message || erro);
    }).then(() => this.processando = false);
  }

  gerarCredenciais() {
    this.execute(() => this.service.gereCredenciaisSoftwareService(this.integracao), (dados: any) => {
      this.apiKeyGerada = dados.apiKey;
      delete dados.apiKey;
      this.integracao = Object.assign({}, this.integracao, dados);
      this.mensagem = 'Credenciais geradas.';
    });
  }

  onboarding() {
    this.executeOperacao('onboarding', () => this.service.executeOnboardingSoftwareService(this.integracao.id),
      async () => {
        await this.atualizeDadosIntegracao();
        return 'Onboarding enviado para a plataforma OpenDelivery.';
      });
  }

  testarPolling() {
    this.executeOperacao('polling', () => this.service.testePollingSoftwareService(this.integracao.id), (dados: any) => {
      return `Teste concluído: ${dados.recebidos} evento(s) disponível(is). Nenhum evento foi processado.`;
    });
  }

  atualizarWebhook() {
    this.mensagemWebhook = '';
    this.erroWebhook = '';
    if(!this.urlWebhookEdicao.trim()) {
      this.erroWebhook = 'Informe a URL que receberá os eventos OpenDelivery.';
      return;
    }
    if(this.frm && this.frm.dirty) {
      this.erroWebhook = 'Antes de atualizar o webhook, salve as alterações da configuração e tente novamente.';
      return;
    }
    this.processando = true;
    this.operacaoEmExecucao = 'webhook';
    this.service.atualizeWebhookSoftwareService(this.integracao.id, this.urlWebhookEdicao.trim()).then((dados: any) => {
      if(dados && dados.apiKey) {
        this.apiKeyGerada = dados.apiKey;
        delete dados.apiKey;
      }
      this.integracao = Object.assign({modoConfiguracao: 'manual', usarTokenFixo: false,
        usarAuthorizationCode: false, pollingAtivo: false, sempreConfirmarPedidos: false}, dados || {});
      this.atualizeIntegracaoNaLista(dados);
      this.urlWebhookEdicao = this.integracao.urlWebhookOnboarding || '';
      this.mensagemWebhook = 'Webhook atualizado no parceiro sem refazer a autorização.';
    }).catch((erro: any) => {
      this.erroWebhook = erro && (erro.message || erro);
    }).then(() => {
      this.operacaoEmExecucao = '';
      this.processando = false;
    });
  }

  soliciteTrocaParaPolling() {
    this.confirmandoTrocaParaPolling = true;
    this.mensagemTrocaRecebimento = '';
    this.erroTrocaRecebimento = '';
  }

  canceleTrocaParaPolling() {
    this.confirmandoTrocaParaPolling = false;
  }

  ativePollingRemovendoWebhook() {
    this.processando = true;
    this.mensagemTrocaRecebimento = '';
    this.erroTrocaRecebimento = '';
    this.service.ativePollingSoftwareService(this.integracao.id).then((dados: any) => {
      this.integracao = dados;
      this.atualizeIntegracaoNaLista(dados);
      this.confirmandoTrocaParaPolling = false;
      this.mensagemTrocaRecebimento = 'Polling ativado. O webhook foi removido no onboarding do parceiro.';
    }).catch((erro: any) => {
      this.erroTrocaRecebimento = erro && (erro.message || erro);
    }).then(() => this.processando = false);
  }

  alterarAtivacao(ativar: boolean) {
    if(!ativar) {
      this.execute(() => this.service.desativeSoftwareService(this.integracao.id), (dados: any) => {
        this.integracao = dados;
        this.atualizeIntegracaoNaLista(dados);
        this.mensagem = 'Integração desativada.';
      });
      return;
    }

    this.erroAtivacao = '';
    if(this.frm && this.frm.dirty) {
      this.erroAtivacao = 'Antes de ativar, salve as alterações da configuração e tente novamente.';
      return;
    }

    this.processando = true;
    this.service.ativeSoftwareService(this.integracao.id).then((dados: any) => {
      this.integracao = dados;
      this.atualizeIntegracaoNaLista(dados);
      this.mensagem = 'Integração ativada.';
    }).catch((erro: any) => {
      this.erroAtivacao = erro && (erro.message || erro);
    }).then(() => this.processando = false);
  }

  copyMessage(valor: string) {
    if(!valor) return;
    const campo = document.createElement('textarea');
    campo.style.position = 'fixed';
    campo.style.left = '0';
    campo.style.top = '0';
    campo.style.opacity = '0';
    campo.value = valor;
    document.body.appendChild(campo);
    campo.focus();
    campo.select();
    document.execCommand('copy');
    document.body.removeChild(campo);
    this.textoCopiado = valor;
  }

  private async atualizeDadosIntegracao() {
    const dados: any = await this.service.obtenhaSoftwareService();
    this.softwareService = dados || {merchantId: '', integracoes: []};
    this.integracoes = this.softwareService.integracoes || [];
    const atualizada = this.integracoes.find((item: any) => Number(item.id) === Number(this.integracao.id));
    if(atualizada) {
      this.apiKeyGerada = atualizada.apiKey || this.apiKeyGerada;
      this.integracao = Object.assign({}, this.integracao, atualizada);
      delete this.integracao.apiKey;
      this.urlWebhookEdicao = this.integracao.urlWebhookOnboarding || '';
    }
  }

  private executeOperacao(operacao: string, acao: () => Promise<any>, mensagem: (dados: any) => string | Promise<string>) {
    this.mensagemOperacao = '';
    this.erroOperacao = '';
    this.mensagem = '';
    this.erro = '';
    this.operacaoEmExecucao = operacao;
    this.ultimaOperacao = operacao;
    this.processando = true;
    acao().then(async (dados: any) => {
      this.mensagemOperacao = await mensagem(dados);
    }).catch((erro: any) => {
      this.erroOperacao = erro && (erro.message || erro);
    }).then(() => {
      this.operacaoEmExecucao = '';
      this.processando = false;
    });
  }

  private execute(acao: () => Promise<any>, sucesso: (dados: any) => void, exibirProcessando = true) {
    this.erro = '';
    this.mensagem = '';
    if(exibirProcessando) this.processando = true;
    acao().then(sucesso).catch((erro: any) => this.erro = erro && (erro.message || erro))
      .then(() => this.processando = false);
  }
}
